// Keep in sync with ClaudeMenuClient::MAX_IMAGE_BYTES / MAX_FILES in the menutranslator backend.
export const MAX_IMAGE_BYTES = 3500000
export const MAX_FILES = 10
// The whole upload (ClaudeMenuClient::MAX_TOTAL_BYTES). Photos are shrunk before upload, so in practice
// this is about PDFs, which are sent as they are.
export const MAX_TOTAL_BYTES = 20000000
const MAX_IMAGE_EDGE = 2400

export function isMenuFile(file) {
  return file.type === 'application/pdf' || file.type.startsWith('image/')
}

// Phone photos are often 5-10MB; shrink them in the browser so they fit the upload limit.
function prepareImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const image = new Image()
    image.onload = () => {
      URL.revokeObjectURL(url)
      const scale = Math.min(1, MAX_IMAGE_EDGE / Math.max(image.width, image.height))
      const canvas = document.createElement('canvas')
      canvas.width = Math.round(image.width * scale)
      canvas.height = Math.round(image.height * scale)
      canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height)
      const encode = quality => canvas.toBlob(blob => {
        if (blob.size > MAX_IMAGE_BYTES && quality > 0.5) {
          encode(quality - 0.15)
        } else {
          resolve(new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }))
        }
      }, 'image/jpeg', quality)
      encode(0.85)
    }
    image.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error(`${file.name} couldn't be opened. Please convert it to JPG or PNG and try again.`))
    }
    image.src = url
  })
}

// Returns FormData with the files (images shrunk) under files[].
export async function menuFilesFormData(files) {
  const prepared = await Promise.all(files.map(file => file.type === 'application/pdf' ? file : prepareImage(file)))
  const formData = new FormData()
  prepared.forEach(file => formData.append('files[]', file))
  return formData
}
